import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '2013437359206134');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark text-white selection:bg-brand-orange selection:text-white overflow-x-hidden" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2013437359206134&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <OpeningHook data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <FailedSolutions data-id="element-7" />
        <UniqueMethod data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <WhoIsItFor data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <ProofSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <PricingCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}